import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useQueryClient, useMutation } from 'react-query'
import styled from 'styled-components'
import colors from '../../configuration/colors'
import { hideModal } from '../../actions/modal'
import withApiData from '../HOC/withApiData'
import Modal from '../mini/Modal'
import FlexAlignCenter from '../presentational/FlexAlignCenter'
import Button from '../mini/Buttons/Button'
import H3 from '../typography/headers/H3'
import P2 from '../typography/paragraphs/P2'
import { returnPublishedActivityToDraft } from '../mycourses/API'

const ModalContainer = styled.div`
  width: 519px;
  border-radius: 8px;
  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);
  background: ${colors.white};
  margin: 180px auto;
  overflow: hidden;
`

const MainContainer = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  background-color: ${colors.white};
  border: none;
  margin: 0 auto;
  padding: 10px 0 0;
  text-align: center;
`

const DescriptionText = styled(H3)`
  width: 419px;
  margin: 0 auto;
  padding: 15px 0;
  text-align: center;
`

const ButtonBlock = styled.div`
  border-top: 1px solid #eeeeee;
`

const EditPublishedActivityModal = ({
  apiData,
  levelId,
  activityQuestId,
  onReturnToDraft
}) => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()

  const editActivityMutation = useMutation(
    ({ apiData, levelId, activityQuestId }) =>
      returnPublishedActivityToDraft(apiData, levelId, activityQuestId)
  )

  const onEditActivityClick = () => {
    editActivityMutation.mutate(
      {
        apiData,
        levelId,
        activityQuestId
      },
      {
        onSuccess: ({ in_draft, last_published_at }) => {
          setTimeout(() => {
            dispatch(hideModal())
            queryClient.setQueryData(['activity-' + activityQuestId], a => ({
              ...a,
              ...{
                in_draft,
                last_published_at
              }
            }))
            onReturnToDraft()
          }, 300)
        }
      }
    )
  }

  const closeTheModal = () => {
    setTimeout(() => {
      dispatch(hideModal())
    }, 300)
  }

  return (
    <Modal
      width={1400}
      percentHeight={100}
      background={'rgba(36,54,70,0.48)'}
      lockBodyScroll={false}
      opacity={'.9'}
      allowInnerScroll
      allowCloseOnExternalClick={false}
    >
      <ModalContainer>
        <div>
          <MainContainer>
            <DescriptionText>This activity is published.</DescriptionText>
          </MainContainer>
          <P2 style={{
            color: '#444444',
            textAlign: 'center',
            padding: '15px 25px 30px 25px'
          }}>
            To edit this activity, a new draft version will be created for you
            to work on. The published version will remain available to students
            until the new version is published.
            <br/><br/>
            A student will not see the new version if they have already began
            this activity prior to the new version being published.
          </P2>
          <ButtonBlock>
            <FlexAlignCenter
              style={{
                justifyContent: 'flex-end',
                padding: '18px 15px 23px 0'
              }}
            >
              <Button
                buttonColor={colors.white}
                width="95px"
                borderColor={colors.aluminum}
                title="Cancel"
                hoverBackground={colors.charcoal4}
                hoverColor={colors.white}
                handleClick={closeTheModal}
              />
              <div style={{ width: '17px' }}>&nbsp;</div>
              <Button
                width="157x"
                title="Edit Activity"
                buttonColor={colors.oeYellow}
                borderColor={colors.oeYellow}
                hoverBackground={colors.charcoal4}
                hoverColor={colors.white}
                handleClick={onEditActivityClick}
              />
            </FlexAlignCenter>
          </ButtonBlock>
        </div>
      </ModalContainer>
    </Modal>
  )
}

EditPublishedActivityModal.propTypes = {
  apiData: PropTypes.object.isRequired,
  levelId: PropTypes.number.isRequired,
  activityQuestId: PropTypes.number.isRequired,
  onReturnToDraft: PropTypes.func.isRequired
}

export default withApiData(EditPublishedActivityModal)



// WEBPACK FOOTER //
// ./src/components/modal/EditPublishedActivityModal.js